module.exports = __webpack_public_path__ + "img/6_120.3fd76de1.png";